import { render, staticRenderFns } from "./boothForm.vue?vue&type=template&id=74061ec3&scoped=true"
import script from "./boothForm.vue?vue&type=script&lang=js"
export * from "./boothForm.vue?vue&type=script&lang=js"
import style0 from "./boothForm.vue?vue&type=style&index=0&id=74061ec3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74061ec3",
  null
  
)

export default component.exports